import { AnalyticsBrowser } from '@segment/analytics-next';
import mixpanel from './mixpanel';

const analytics = new AnalyticsBrowser();

// Copied from docs
// https://docs.mixpanel.com/docs/session-replay/implement-session-replay/session-replay-web#segment-analyticsjs
analytics.addSourceMiddleware(({ payload, next, integrations }) => {
  if (payload.obj.type === 'track' || payload.obj.type === 'page') {
    const segmentDeviceId = payload.obj.anonymousId;

    mixpanel.register({
      $device_id: segmentDeviceId,
      distinct_id: '$device:' + segmentDeviceId,
    });

    const sessionReplayProperties = mixpanel.get_session_recording_properties();
    payload.obj.properties = {
      ...payload.obj.properties,
      ...sessionReplayProperties,
    };
  }

  if (payload.obj.type === 'identify') {
    const userId = payload.obj.userId;
    mixpanel.identify(userId as string);
  }

  next(payload);
});

export default analytics;
